// Promocions pròpies que es mostren mentre es prepara una transcripció.
export const NATIVE_ADS = [
  {
    id: 'actuacions-castelleres',
    headline: 'Impressiona el teu públic internacional amb castellers',
    body: "Actuacions castelleres en directe per a congressos i sopars d'empresa. T'ho expliquem tot en 10 minuts.",
    cta: 'Demana pressupost',
    displayUrl: 'actuacionscastelleres.cat',
    href: 'https://actuacionscastelleres.cat/?utm_source=fesmelacta&utm_medium=native_ad&utm_campaign=transcription_loading',
    image: '/assets/progress/actuacions-castelleres.webp',
    imageAlt: 'Castellers aixecant un castell al capvespre davant del mar',
  },
];

export function pickNativeAd(ads = NATIVE_ADS, random = Math.random) {
  if (!ads.length) return null;
  return ads[Math.floor(random() * ads.length)];
}
